// src/components/XMLFeedAnalysis.tsx
import React, { useState, useRef } from "react";
import FeedForm from "../components/FeedForm";
import Results from "../components/Results";
import {
  parseFeed,
  extractShopLink,
  detectFeedType,
} from "../utils/feedParser";
import { compareFeeds } from "../utils/utils";
import "./XMLFeedAnalysis.css";
import axios from "axios";

const XMLFeedAnalysis: React.FC = () => {
  const [processingState, setProcessingState] = useState({
    isProcessing: false,
    isComplete: false,
    progress: 0,
    oldProducts: {} as { [id: string]: string },
    newProducts: {} as { [id: string]: string },
    missingProducts: {} as { [id: string]: string },
  });

  const feedFormRef = useRef<any>(null);

  const urlApi = "https://analyse-feed-holub.onrender.com";

  const handleFormSubmit = async (oldFeed: File, newFeed: File) => {
    setProcessingState((prev) => ({
      ...prev,
      isProcessing: true,
      isComplete: false,
      progress: 0,
    }));

    try {
      const [oldContent, newContent] = await Promise.all([
        oldFeed.text(),
        newFeed.text(),
      ]);

      // Parsing feeds
      const oldProducts = parseFeed(oldContent);
      setProcessingState((prev) => ({ ...prev, progress: 33 }));

      const newProducts = parseFeed(newContent);
      setProcessingState((prev) => ({ ...prev, progress: 66 }));

      // Calculate missing products
      const missing = compareFeeds(oldProducts, newProducts);
      const missingCount = Object.keys(missing).length;

      // Send analytics data
      try {
        const apiUrl = urlApi;
        await axios.post(`${apiUrl}/api/feed-analysis`, {
          format: detectFeedType(newContent),
          analysisDate: new Date().toISOString(),
          shopLink: extractShopLink(newContent),
          totalMissingProducts: missingCount,
        });
      } catch (error) {
        console.error("Error sending analytics:", error);
      }

      setProcessingState({
        isProcessing: false,
        isComplete: true,
        progress: 100,
        oldProducts,
        newProducts,
        missingProducts: missing,
      });
    } catch (error) {
      console.error("Error processing files:", error);
      setProcessingState((prev) => ({
        ...prev,
        isProcessing: false,
        isComplete: true,
        progress: 0,
      }));
    }
  };

  const handleReset = () => {
    setProcessingState({
      isProcessing: false,
      isComplete: false,
      progress: 0,
      oldProducts: {},
      newProducts: {},
      missingProducts: {},
    });

    feedFormRef.current?.resetForm();
  };

  return (
    <div className="App">
      <h1>Nahraj XML feedy pro porovnání</h1>
      <p className="supported-feeds">
        Podporuje feedy: Google Nákupy, Pemacz, Heureka
      </p>

      <FeedForm ref={feedFormRef} onSubmit={handleFormSubmit} />

      {processingState.isProcessing && (
        <div className="spinner-container">
          <div className="spinner"></div>
          <div className="progress">{processingState.progress}%</div>
        </div>
      )}

      <Results
        missingProducts={processingState.missingProducts}
        isProcessingComplete={processingState.isComplete}
        onReset={handleReset}
      />
    </div>
  );
};

export default XMLFeedAnalysis;
